import { makeStyles } from '@material-ui/core/styles';
import { secondaryButtonStyle } from '../../../../shared/styles/buttons.styles';
import { redesignTheme } from '../../../../theme';

const { colors, fonts, fontSize, spacing, breakpoints } = redesignTheme;

export const useRecommendedTestsSectionStyles = makeStyles(() => ({
  recommendedSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.md,
    marginTop: spacing.xl,
  },
  recommendedHeader: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.sm,
    [`@media (min-width: ${breakpoints.tablet}px)`]: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
  },
  recommendedTitle: {
    margin: 0,
    fontFamily: fonts.gothicSemiBold,
    fontSize: fontSize.lg,
    color: colors.primaryDark,
    lineHeight: 'normal',
  },
  discoverAllButton: {
    ...secondaryButtonStyle,
    alignSelf: 'flex-start',
    whiteSpace: 'nowrap',
    flexShrink: 0,
  },
  cardGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(232px, 1fr))',
    gap: 20,
    alignItems: 'stretch',
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      display: 'flex',
      overflowX: 'auto',
      gap: 20,
      scrollSnapType: 'x proximity',
      WebkitOverflowScrolling: 'touch',
      scrollbarWidth: 'none',
      '&::-webkit-scrollbar': {
        display: 'none',
      },
    },
  },
  cardGridItem: {
    display: 'flex',
    minHeight: '100%',
    '& > *': {
      flex: 1,
      width: '100%',
      minHeight: '100%',
    },
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      flex: '0 0 232px',
      width: 232,
      scrollSnapAlign: 'start',
    },
  },
}));
